export default __webpack_public_path__ + "static/media/menu.b109cfc6.svg";